'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ComponentProps, MouseEvent, useState } from 'react';

export default function TransitionLink({
  href,
  children,
  onClick,
  ...props
}: ComponentProps<typeof Link>) {
  const router = useRouter();
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleTransition = async (e: MouseEvent<HTMLAnchorElement>) => {
    // Allow an optional custom onClick to run first
    if (onClick) {
      onClick(e);
    }

    // If the custom handler prevented default, don't run the transition logic
    if (e.defaultPrevented) {
      return;
    }

    // Prevent default navigation and run the fade transition
    e.preventDefault();
    
    if (isTransitioning) return;
    setIsTransitioning(true);
    
    const body = document.body;

    // Add class to fade out
    body.classList.add('pageTransitioningOut');
    
    // Wait for fade out animation
    await new Promise(resolve => setTimeout(resolve, 400));
    
    // Navigate to new page
    router.push(href.toString());
    
    // Wait for the page to be ready
    // Use requestAnimationFrame to wait for next paint cycle
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Wait additional time for images and assets to load
          setTimeout(resolve, 600);
        });
      });
    });
    
    // Fade in
    body.classList.remove('pageTransitioningOut');
    setIsTransitioning(false);
  };

  return (
    <Link 
      href={href} 
      // className={`transitionLink`}
      onClick={handleTransition} 
      prefetch={true}
      {...props}
    >
      {children}
    </Link>
  );
}
